import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';
import React, { useEffect } from 'react';

import landingPageTheme from '@/@mantis/theme/landingPageTheme';
import '@/styles/landingPage.css';

import FooterSection from './sections/FooterSection';
import NavSection from './sections/NavSection';
import PricingHeroSection from './sections/PricingHeroSection';
import PricingPlansSection from './sections/PricingPlansSection';

// Custom wrapper for the pricing page with the landing page theme
const PricingPageWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Create a theme instance specifically for the pricing page using landing page theme
  const theme = createTheme(landingPageTheme);

  // Add preload link for Nohemi font to improve loading on mobile
  useEffect(() => {
    const fontPreloadLinks = [
      { href: '/assets/fonts/Nohemi-Regular.woff2', type: 'font/woff2' },
      { href: '/assets/fonts/Nohemi-SemiBold.woff', type: 'font/woff' },
    ];

    fontPreloadLinks.forEach(font => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.href = font.href;
      link.as = 'font';
      link.type = font.type;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    });

    return () => {
      fontPreloadLinks.forEach(font => {
        const links = document.querySelectorAll(`link[href="${font.href}"]`);
        links.forEach(link => link.remove());
      });
    };
  }, []);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div style={{ height: '100%', overflowY: 'auto', overflowX: 'hidden' }}>{children}</div>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

const PricingPage: React.FC = () => (
  <PricingPageWrapper>
    <NavSection />
    <PricingHeroSection />
    <PricingPlansSection />
    <FooterSection />
  </PricingPageWrapper>
);

export default PricingPage;
